import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPermissionsMembers,
  PERMISSIONS,
  selectPermissionsMembers,
  selectPermissionsMembersAvailable,
} from "slices/peopleSlice";
import PeopleList from "components/Home/People/PeopleList/PeopleList.js";
import PeopleItem from "components/Home/People/PeopleItem/PeopleItem";
import Avatar from "components/Home/ui/Avatar";
import { iAmAdmin } from "helpers/efficeHelpers";

const MemberSideList = ({ pid, type, myDeets, permissionsEffice }) => {
  const dispatch = useDispatch();
  const memberData = useSelector(selectPermissionsMembers);
  const membersAvailable = useSelector(selectPermissionsMembersAvailable);

  return (
    <>
      <div style={{ overflowY: "auto", marginBottom: "5px", width: "310px" }}>
        <div className="content-wrapper">
          <div className="me">
            <PeopleItem
              type={PERMISSIONS}
              user_id={myDeets.id}
              given_name={myDeets.given_name}
              customStyle={{ width: "215px" }}
              family_name={myDeets.family_name}
              currentUserId={myDeets.id}
              other_role_id={permissionsEffice.role_id}
              permissionsEffice={permissionsEffice}
              avatar={
                <div className={`Txt-avatar d-inline-block`}>
                  <Avatar
                    avatar_key={myDeets.avatar_key}
                    given_name={myDeets.given_name}
                    family_name={myDeets.family_name}
                  />
                </div>
              }
            />
          </div>

          <PeopleList
            people={
              memberData
                ? memberData.filter((elem) => elem.id !== myDeets.id)
                : null
            }
            fetch={(more = false) => {
              return dispatch(getPermissionsMembers(pid, more));
            }}
            available={membersAvailable}
            meAdmin={iAmAdmin(permissionsEffice)}
            type={type}
            currentUserId={myDeets.id}
            permissionsEffice={permissionsEffice}
          />
        </div>
      </div>
    </>
  );
};
export default MemberSideList;
